import DigitalWelcomeCall from "public/images/enerflo-digital-welcome-calls-callpilot.png";
import AutomatedCommunicationImageMobile from "public/images/enerflo-solar-platform-automated-communications-mobile.png";
import AutomatedCommunicationImage from "public/images/enerflo-solar-platform-automated-communications.png";
import ChangeOrdersImageMobile from "public/images/enerflo-solar-platform-change-orders-mobile.png";
import ChangeOrdersImage from "public/images/enerflo-solar-platform-change-orders.png";
import CustomReportsImageMobile from "public/images/enerflo-solar-platform-custom-reports-mobile.png";
import CustomReportsImage from "public/images/enerflo-solar-platform-custom-reports.png";
import ActionGroupsImageMobile from "public/images/enerflo-solar-platform-project-action-groups-mobile.png";
import ActionGroupsImage from "public/images/enerflo-solar-platform-project-action-groups.png";
import ProjectMilestoneManagementImageMobile from "public/images/enerflo-solar-platform-project-milestone-management-mobile.png";
import ProjectMilestoneManagementImage from "public/images/enerflo-solar-platform-project-milestone-management.png";
import TasksImageMobile from "public/images/enerflo-solar-platform-tasks-mobile.png";
import TasksImage from "public/images/enerflo-solar-platform-tasks.png";
import ProjectSubmissionImageMobile from "public/images/enerflo-solar-project-submission-workflow-mobile.png";
import ProjectSubmissionImage from "public/images/enerflo-solar-project-submission-workflow.png";

const features = [
  {
    title: "Project Submission",
    description: (
      <span>
        Stop dirty deals from ever getting submitted with a custom-made workflow that ensures every deal has a utility
        bill, signed loan docs, cleared stips and more <span className="font-bold">before</span> the project hits your
        ops team. Enerflo clearly shows your sales reps what’s missing and what they need to fix before the system
        allows them to submit the project automatically to your teams or 3rd party systems. Manual entry forms? No,
        thank you.
      </span>
    ),
    image: ProjectSubmissionImage,
    imageMobile: ProjectSubmissionImageMobile,
    imageAlt: "Stop dirty deals in their tracks with Enerflo’s Solar Project Submission workflow and requirements.",
  },
  {
    title: "Digital Welcome Calls",
    description:
      "CallPilot’s Digital Welcome Call integration with Enerflo enables a smoother, faster Welcome Call experience for sales reps and customers, with on-demand 24/7, fully-automated, cloud-based surveys. Sales Reps and customers enjoy zero hold times and reduced call times, and installers enjoy data accuracy and integrity without recording or transcription errors. ",
    image: DigitalWelcomeCall,
    imageMobile: DigitalWelcomeCall,
    imageAlt: "Enerflo Digital Welcome Calls powered by CallPilot, a cloud-based enterprise level TPV application.",
  },
  {
    title: "Project Milestone Management",
    description:
      "Your project milestones are enhanced with automated notifications sent to both customers and sales reps to inform them on progress. Reduce calls and needless communications. Plus, with seamless 3rd party CRM integrations, Enerflo can automatically move milestones based on changes made in an external tool, keeping everything in sync.",
    image: ProjectMilestoneManagementImage,
    imageMobile: ProjectMilestoneManagementImageMobile,
    imageAlt:
      "Enerflo Project Milestone Management is tailored to the unique milestones that define the work involved for your company to get glass on roof.",
  },
  {
    title: "Automate Communication",
    description:
      "Easily send communications via SMS or email for your customers and sales reps. Send communications when key milestones are reached and show upcoming site surveys or install appointments on the Enerflo Customer Portal. Project Managers gain visibility on all inbound communication from the customer or sales rep on every project to keep everything running smoothly.",
    image: AutomatedCommunicationImage,
    imageMobile: AutomatedCommunicationImageMobile,
    imageAlt: "Enerflo easily automates communications via SMS or email messages for solar customers and sales reps.",
  },
  {
    title: "Project Action Groups",
    description:
      "Enerflo’s Project Action Groups enable you to group custom fields and milestones to ensure data gets added properly at each step. Create as many action groups as you need, auto-assign owners for each task and automate notifications for them when it’s their turn to fulfill that part of the project install. Use your new-found time to grow your business… or take a vacation.",
    image: ActionGroupsImage,
    imageMobile: ActionGroupsImageMobile,
    imageAlt:
      "Enerflo’s Project Action Groups enable you to group custom fields and milestones to ensure data gets added properly at each step.",
  },
  {
    title: "Project Tasks",
    description:
      "Leave no stone unturned. When specific things need to get done, create tasks for your ops team or sales reps in Enerflo, or automatically push tasks from your 3rd party tool using our Task API. Automatically send reminders on uncompleted tasks and quickly see projects that have outstanding tasks. Simply put, make sure stuff is getting done.",
    image: TasksImage,
    imageMobile: TasksImageMobile,
    imageAlt:
      "Create tasks for your ops team or sales reps in Enerflo, or push tasks from your 3rd party tool using our Task API.",
  },
  {
    title: "Build Custom Reports",
    description:
      "Holy shiznit, Batman, that’s a ton of data! Enerflo Custom Reports cut through the noise. Modify columns, adjust sorting, filter on specific data and save as many as you need to easily refer to them later. Only want to see jobs that have an MPU? Done. Want to create an aging report of jobs that are still in permitting after 2 weeks. No problem. Get to the data you need, quickly and easily.",
    image: CustomReportsImage,
    imageMobile: CustomReportsImageMobile,
    imageAlt: "Create and save as many Enerflo Custom Reports as you’d like to get the data you need fast.",
  },
  {
    title: "Integrated Change Orders",
    description:
      "Enerflo reduces change orders by improving accuracy upstream, but... they still happen. When they do, Enerflo’s intuitive change order process allows you to modify adders, pricing, system details and more. Easily send addendums to your customers for signature and display the new details automatically in your reporting, while keeping a history of all changes made. As if that wasn’t enough, Enerflo automatically syncs the data to the integrated lender, saving your team the headache of manually updating changes to reach NTP.",
    image: ChangeOrdersImage,
    imageMobile: ChangeOrdersImageMobile,
    imageAlt:
      "Enerflo’s intuitive change order process allows modification of adders, pricing, system details and more.",
  },
];

export default features;
